import { createAction, createActionWithPath } from 'Modules/core/redux';


const actionTypes = {
    INITIALIZE: 'INITIALIZE',
    SET_ENVIRONMENT: 'ENVIRONMENT',
    REQUEST_LOGOUT: 'REQUEST_LOGOUT',
    SET_BUSY: 'SET_BUSY',
};

export { actionTypes as environmentActionTypes };

export const environmentActions = {
    initialize: createAction(actionTypes.INITIALIZE),
    setEnvironment: createAction(actionTypes.SET_ENVIRONMENT),
    requestLogout: createAction(actionTypes.REQUEST_LOGOUT),
    setBusy: createActionWithPath(actionTypes.SET_BUSY),
};
